import RouteNames from "@/entities/RouteNames";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import NavigationIcons from "@/entities/NavigationIcons";
import RouteWrapper from "@/components/common/RouteWrapper.vue";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";

const Connections = () =>
  import("@/views/network/Connections.vue").then((m) => m.default);

const getConnectionsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/connections",
    component: RouteWrapper,
    meta: {
      breadcrumb: {
        title: BreadcrumbsTitles.CONNECTIONS,
        icon: NavigationIcons.GROUPS,
        isStyled: true,
      },
    },
    children: [
      {
        path: "",
        name: RouteNames.NETWORK_CONNECTIONS,
        component: Connections,
        meta: {
          title: "Connections",
          roles: [Roles.CONTRACTOR],
          breadcrumb: {
            isStyled: true,
          },
        },
      },
    ],
  },
]);

export { getConnectionsRoutes };
